import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ConnectedFlightsManager } from './FlightsManager';
import { AirlineFilterSelector } from '../AirlineFilterSelector/AirlineFilterSelector';
import { TripTypeSelectorMobile } from '../TripTypeSelector';
import { SegmentManagerMobile } from './Segment/SegmentManager';
import { PaxSelectorMobile } from '../PaxSelector';
import { ResidentDiscount } from '../ResidentDiscount/ResidentDiscountMobile';
import { SlideGroupContextProvider } from '../../components/SlideManager';
import { ABUtils, isTrainsRoundTripDiscountCard } from '../../utils';
import { isTrainsProductActive } from '../../redux/currentSearch/selectors';
import { prefetchAssets } from '../../utils/PrefetchUtils';
import { ButtonCTA } from './MobileFragments/ButtonCTA';
import {
    getWrapperClassNames,
    getTripTypeWrapperClassNames,
    getSecondaryButtonClassNames,
} from './FlightsManagerMobileUtils';

export const SegmentManagerAndPaxSelector = ({
    isHotelOptionEnabled,
    displayPaxStandaloneInput: displayPaxStandaloneInputProp,
    tripType,
}) => {
    const isTrainsProduct = useSelector(isTrainsProductActive);
    const isRailsRoundTripDiscountCard = isTrainsRoundTripDiscountCard({ isTrainsProduct, tripType });
    const displayPaxStandaloneInput = displayPaxStandaloneInputProp || isRailsRoundTripDiscountCard;

    return (
        <React.Fragment>
            <SegmentManagerMobile />
            {displayPaxStandaloneInput && (
                <PaxSelectorMobile isHotelOptionEnabled={isRailsRoundTripDiscountCard ? false : isHotelOptionEnabled} />
            )}
        </React.Fragment>
    );
};

export const FlightsManagerMobile = ({ isHotelOptionEnabled, rootDataAttr }) => {
    prefetchAssets();

    const {
        isCssVariationMobile,
    } = ABUtils.getABs();
    const { airlinefilteriata: airlineIata, airlinefiltername: airlineName } = rootDataAttr;

    const wrapperClassNames = getWrapperClassNames(
        isCssVariationMobile,
    );
    const tripTypeWrapperClassNames = getTripTypeWrapperClassNames(isCssVariationMobile);
    const secondaryButtonClassNames = getSecondaryButtonClassNames(isCssVariationMobile);

    return (
        <div>
            <ConnectedFlightsManager
                rootDataAttr={rootDataAttr}
                render={({ tripType }) => (
                    <React.Fragment>
                        <div className={wrapperClassNames}>
                            <div className={tripTypeWrapperClassNames}>
                                <TripTypeSelectorMobile />
                            </div>
                            <SlideGroupContextProvider>
                                <SegmentManagerAndPaxSelector
                                    isHotelOptionEnabled={isHotelOptionEnabled}
                                    displayPaxStandaloneInput={tripType !== 'roundTrip'}
                                    tripType={tripType}
                                />
                            </SlideGroupContextProvider>

                            {airlineIata && airlineName && (
                                <div className="odf-flex-item odf-flex-item-align-center">
                                    <AirlineFilterSelector
                                        airlineIata={airlineIata}
                                        airlineName={airlineName}
                                    />
                                </div>
                            )}
                            <ResidentDiscount />
                            <ButtonCTA
                                isHotelOptionEnabled={isHotelOptionEnabled}
                                isSearchFragmentPage={false}
                                tripType={tripType}
                                buttonWrapperClassNames="odf-space-outer-top-m"
                                secondaryButtonClassNames={secondaryButtonClassNames}
                            />
                        </div>
                    </React.Fragment>
                )}
            />
        </div>
    );
};

FlightsManagerMobile.propTypes = {
    isHotelOptionEnabled: PropTypes.bool,
};

FlightsManagerMobile.defaultProps = {
    isHotelOptionEnabled: true,
    rootDataAttr: {
        airlinefilteriata: null,
        airlinefiltername: null,
    },
};
